import React, { useState, useEffect } from 'react';
import PremiumTag from './PremiumTag';
import { List, ListItem, ListItemText, Box } from '@mui/material';

function Menu({ items, onMenuSelect, selectedMenuIndex }) {
    const [selectedIndex, setSelectedMenuIndex] = useState(selectedMenuIndex);

    // Sync state when `selectedMenuIndex` prop changes
    useEffect(() => {
        setSelectedMenuIndex(selectedMenuIndex);
    }, [selectedMenuIndex]);

    return (
        <Box sx={{ marginLeft: 4 }}>
            <List sx={{ display: 'flex' }}>
                {items.map((item, index) => (
                    <ListItem
                        button
                        key={index}
                        onClick={(event) => {
                            if (!item.subOptions) {
                                setSelectedMenuIndex(index);
                            }
                            onMenuSelect(index, null, event);
                        }}
                        selected={selectedIndex === index}
                        sx={{
                            textAlign: 'center',
                            borderBottom: selectedIndex === index ? '1px solid #4680ff' : '1px solid transparent',
                            transition: 'border-bottom 0.3s ease',
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: 'inherit',
                            } 
                        }}
                    >
                        {item.icon && (item.icon())}
                        <ListItemText
                            primary={item.title}
                            sx={{ 
                                    whiteSpace: 'nowrap',
                                    color: '#757575',
                                    transition: 'color 0.3s ease',
                                    '&:hover': {
                                        color: 'black',
                                    },
                                    marginRight: { xs: '0', sm: item.isPremium ? '10px' : '0'}
                            }}
                        />
                        {item.isPremium && <PremiumTag/>}
                    </ListItem>
                ))}
            </List>
        </Box>
    );
}

export default Menu;